/**
 * Application Constants
 * Centralized constants used throughout the application
 */

// Re-export API constants
export * from './api.constants';

// Local Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'authToken',
  USER: 'user',
  DOCTOR_REGISTRATION_DATA: 'doctorRegistrationData',
  ONBOARDING_COMPLETED_STEPS: 'onboardingCompletedSteps',
  ONBOARDING_DATA: 'onboardingData',
} as const;

// User Roles (Backend format)
export const USER_ROLES = {
  ADMIN: 'CLINIC_ADMIN',
  DOCTOR: 'DOCTOR',
  RECEPTIONIST: 'RECEPTIONIST',
  PATIENT: 'PATIENT',
} as const;

// Pagination
export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = ['10', '20', '50', '100'];

// Date Formats (USA Standard - 12-hour time with AM/PM)
export const DATE_FORMATS = {
  DISPLAY: 'MM/DD/YYYY',                          // 01/29/2026
  DISPLAY_MONTH: 'MM/YYYY',                       // 01/2026
  DISPLAY_WITH_TIME: 'MM/DD/YYYY h:mm A',         // 01/29/2026 2:30 PM (12-hour)
  DISPLAY_VERBOSE: 'MMM DD, YYYY',                // Jan 29, 2026
  DISPLAY_VERBOSE_WITH_TIME: 'MMM DD, YYYY h:mm A', // Jan 29, 2026 2:30 PM (12-hour)
  DISPLAY_FULL: 'MMMM DD, YYYY',                  // January 29, 2026
  DISPLAY_FULL_WITH_TIME: 'MMMM DD, YYYY [at] h:mm A', // January 29, 2026 at 2:30 PM
  TIME_ONLY: 'h:mm A',                            // 2:30 PM (12-hour only)
  TIME_ONLY_WITH_SECONDS: 'h:mm:ss A',            // 2:30:45 PM
  API: 'YYYY-MM-DD',                              // 2026-01-29 (for API submission)
  API_WITH_TIME: 'YYYY-MM-DD HH:mm:ss',           // 2026-01-29 14:30:00 (for API submission)
} as const;

// Validation
export const VALIDATION = {
  PASSWORD_MIN_LENGTH: 8,
  PHONE_LENGTH: 10,
  NPI_LENGTH: 10,
} as const;

// USA-Specific Constants
export * from './usa.constants';






